import translation from './zh/translation';
export { translation as zh };
export default { zh: { translation } };